// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar {
    position: relative;
}

.react-calendar {
    width: 100%;
    /* min-width: 1200px; */
    border: none;
    border-radius: 0.5rem;
    /* box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161); */
    /* padding-top: 50px; */
    background-color: transparent;
    /* border: 1px solid #ffffff; */
}

/* 전체 폰트 컬러 */
.react-calendar__month-view {
    color: black;
}

/* 네비게이션 가운데 정렬 */
.react-calendar__navigation {
    justify-content: flex-start;
}

/* 네비게이션 폰트 설정 */
.react-calendar__navigation button {
    font-weight: 800;
    font-size: 1rem;
}

/* 네비게이션 버튼 컬러 */
.react-calendar__navigation button:focus {
    background-color: white;
}

/* 네비게이션 비활성화 됐을때 스타일 */
.react-calendar__navigation button:disabled {
    background-color: transparent;
    color: darkblue;
}

/* 년/월 상단 네비게이션 칸 크기 줄이기 */
.react-calendar__navigation__label {
    flex-grow: 0 !important;
}

/* 요일 밑줄 제거 */
.react-calendar__month-view__weekdays abbr {
    text-decoration: none;
    font-weight: 800;
}

/* 일요일에만 빨간 폰트 */
.react-calendar__month-view__weekdays__weekday--weekend abbr[title="일요일"] {
    color: red;
}

/* 오늘 날짜 폰트 컬러 */
.react-calendar__tile--now {
    background: none;
    /* color: white; */
}

/* 네비게이션 월 스타일 적용 */
.react-calendar__year-view__months__month {
    border-radius: 0.8rem;
    /* background-color: gray; */
    padding: 0;
}

/* 네비게이션 현재 월 스타일 적용 */
.react-calendar__tile--hasActive {
    background-color: orange;
    color: white;
}

/* 일 날짜 간격 */
.react-calendar__tile {
    padding: 10px 0px;
    position: relative;
    /* height: 210px; */
    height: 150px;
    border-right: 2px solid rgb(241, 243, 244) !important;
    border-bottom: 2px solid rgb(241, 243, 244) !important;
    background-color: #fff !important;
    display: flex;
    justify-content: center;
}

.StyledCalendarWrapper.dark .react-calendar__tile {
    background-color: #494848 !important;
    border: 1px solid #5f5e5e !important;
    color: #121214;
}

/* 네비게이션 월 스타일 적용 */
.react-calendar__year-view__months__month {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.3333% - 10px);
    /* margin-inline-start: 5px !important; */
    /* margin-inline-end: 5px !important; */
    margin-block-end: 10px;
    padding: 20px 6.6667px;
    font-size: 0.9rem;
    font-weight: 600;
    color: black;
}

.react-calendar__month-view__days {
    border-left: 2px solid rgb(241, 243, 244) !important;
    border-top: 2px solid rgb(241, 243, 244) !important;
}

.StyledCalendarWrapper.dark .react-calendar__month-view__days {
    border: 1px solid #5f5e5e !important;
}

/* 선택한 날짜 스타일 적용 */
/* .react-calendar__tile:enabled:focus,
.react-calendar__tile--active,
.react-calendar__tile--active:hover {
    background-color: #ffe2a8 !important;
    border: 1px solid #ffe2a8 !important;
    border-radius: 0.3rem;
    color: black;
} */

.react-calendar__tile:enabled:hover {
    background-color: #f3f3f3 !important;
}

.StyledCalendarWrapper.dark .react-calendar__tile:enabled:hover {
    background-color: #636363 !important;
}

.react-calendar__tile:enabled:focus,
.react-calendar__tile--active,
.react-calendar__tile--active:hover {
    color: black;
}

.react-calendar__tile--active abbr {
    background-color: #ffd37e !important;
}

.react-calendar__month-view__days__day abbr {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.StyledDate {
    border: none;
    box-shadow: none;
    background: #94a3b8;
    font-weight: 500;
    text-shadow: none;
    color: #fff;
    opacity: 1;
    height: 2rem;
    padding: 0 1rem;
    line-height: 2rem;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 20px;
}

.StyledToday {
    font-size: x-small;
    color: navy;
    font-weight: 600;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
}

.StyledDot {
    background-color: navy;
    border-radius: 50%;
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
}

.StyledEX-hoilday {
    font-size: 11px;
    color: black;
    font-weight: 600;
    position: absolute;
    top: 50px;
    width: 100%;
}

.StyledEX {
    font-size: 11px;
    color: black;
    font-weight: 600;
    position: absolute;
    top: 80px;
    width: 100%;
}

.StyledEX-1,
.StyledEX-2,
.StyledEX-3,
.StyledEX-4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.StyledEX-1 {
    width: 100%;
    /* height: 14px; */
    background-color: #e59e2f !important;
    border-radius: 5px;
    margin-bottom: 5px;
}

.StyledEX-2 {
    width: 100%;
    height: 14px;
    background-color: #1c658c !important;
    border-radius: 5px;
    margin-bottom: 5px;
}

.StyledEX-3 {
    width: 100%;
    height: 14px;
    background-color: #064e3b !important;
    border-radius: 5px;
}

.StyledEX-4 {
    width: 100%;
    height: 14px;
    background-color: #6f5689 !important;
    border-radius: 5px;
}

.StyledEX-holiday {
    width: 100%;
    /* width: calc(100% - 10px); */
    /* height: 14px; */
    background-color: rgb(244, 81, 30);
    text-align: left;
    color: #fff;
    height: 22px;
    line-height: 20px;
    padding: 0 8px;
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;

    box-sizing: border-box;
    pointer-events: auto;
    overflow: hidden;
    display: flex;
    outline: none;
    align-items: center;
}

/* 전달, 다음 달의 날짜는 회색 */
.react-calendar__month-view__days__day--neighboringMonth {
    background-color: #f9f9f9 !important;
    color: #c5c5c5;
}

.calendar-right {
    width: 230px;
    border: 2px solid rgb(241, 243, 244);
    margin-top: 85px;
}

.calendar-right-text {
    padding: 10px;
    font-weight: bold;
}

.calendar-right-holiday {
    height: 45px;
    border-left: 4px solid rgb(244, 81, 30);
    margin: 5px 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.calendar-right-day {
    height: 45px;
    border-left: 4px solid #567189;
    margin: 5px 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
}

.calendar-right-day:hover {
    background-color: #f1f1f1;
}

.calendar-icon {
    padding: 3px 10px;
    border: 1px solid rgba(0, 0, 0, .14);
    border-radius: 5px;
    margin-left: 5px;
    cursor: pointer;
}

.calendar-icon:hover {
    background-color: #f1f1f1;
}

.calendar-icon.active {
    background-color: #e3e3e3;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/calendar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB,sDAAsD;IACtD,uBAAuB;IACvB,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA,aAAa;AACb;IACI,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,uBAAuB;AAC3B;;AAEA,aAAa;AACb;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,qDAAqD;IACrD,sDAAsD;IACtD,iCAAiC;IACjC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,YAA0C;IAA1C,cAA0C;IAA1C,iCAA0C;IAC1C,yCAAyC;IACzC,uCAAuC;IACvC,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oDAAoD;IACpD,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;;;;;;;GAOG;;AAEH;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;;;;IAII,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;;IAElB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAGhB,aAAa;IACb,aAAa;IAGb,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uCAAuC;IACvC,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".calendar {\r\n    position: relative;\r\n}\r\n\r\n.react-calendar {\r\n    width: 100%;\r\n    /* min-width: 1200px; */\r\n    border: none;\r\n    border-radius: 0.5rem;\r\n    /* box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161); */\r\n    /* padding-top: 50px; */\r\n    background-color: transparent;\r\n    /* border: 1px solid #ffffff; */\r\n}\r\n\r\n/* 전체 폰트 컬러 */\r\n.react-calendar__month-view {\r\n    color: black;\r\n}\r\n\r\n/* 네비게이션 가운데 정렬 */\r\n.react-calendar__navigation {\r\n    justify-content: flex-start;\r\n}\r\n\r\n/* 네비게이션 폰트 설정 */\r\n.react-calendar__navigation button {\r\n    font-weight: 800;\r\n    font-size: 1rem;\r\n}\r\n\r\n/* 네비게이션 버튼 컬러 */\r\n.react-calendar__navigation button:focus {\r\n    background-color: white;\r\n}\r\n\r\n/* 네비게이션 비활성화 됐을때 스타일 */\r\n.react-calendar__navigation button:disabled {\r\n    background-color: transparent;\r\n    color: darkblue;\r\n}\r\n\r\n/* 년/월 상단 네비게이션 칸 크기 줄이기 */\r\n.react-calendar__navigation__label {\r\n    flex-grow: 0 !important;\r\n}\r\n\r\n/* 요일 밑줄 제거 */\r\n.react-calendar__month-view__weekdays abbr {\r\n    text-decoration: none;\r\n    font-weight: 800;\r\n}\r\n\r\n/* 일요일에만 빨간 폰트 */\r\n.react-calendar__month-view__weekdays__weekday--weekend abbr[title=\"일요일\"] {\r\n    color: red;\r\n}\r\n\r\n/* 오늘 날짜 폰트 컬러 */\r\n.react-calendar__tile--now {\r\n    background: none;\r\n    /* color: white; */\r\n}\r\n\r\n/* 네비게이션 월 스타일 적용 */\r\n.react-calendar__year-view__months__month {\r\n    border-radius: 0.8rem;\r\n    /* background-color: gray; */\r\n    padding: 0;\r\n}\r\n\r\n/* 네비게이션 현재 월 스타일 적용 */\r\n.react-calendar__tile--hasActive {\r\n    background-color: orange;\r\n    color: white;\r\n}\r\n\r\n/* 일 날짜 간격 */\r\n.react-calendar__tile {\r\n    padding: 10px 0px;\r\n    position: relative;\r\n    /* height: 210px; */\r\n    height: 150px;\r\n    border-right: 2px solid rgb(241, 243, 244) !important;\r\n    border-bottom: 2px solid rgb(241, 243, 244) !important;\r\n    background-color: #fff !important;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__tile {\r\n    background-color: #494848 !important;\r\n    border: 1px solid #5f5e5e !important;\r\n    color: #121214;\r\n}\r\n\r\n/* 네비게이션 월 스타일 적용 */\r\n.react-calendar__year-view__months__month {\r\n    flex: 0 0 calc(33.3333% - 10px) !important;\r\n    /* margin-inline-start: 5px !important; */\r\n    /* margin-inline-end: 5px !important; */\r\n    margin-block-end: 10px;\r\n    padding: 20px 6.6667px;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    color: black;\r\n}\r\n\r\n.react-calendar__month-view__days {\r\n    border-left: 2px solid rgb(241, 243, 244) !important;\r\n    border-top: 2px solid rgb(241, 243, 244) !important;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__month-view__days {\r\n    border: 1px solid #5f5e5e !important;\r\n}\r\n\r\n/* 선택한 날짜 스타일 적용 */\r\n/* .react-calendar__tile:enabled:focus,\r\n.react-calendar__tile--active,\r\n.react-calendar__tile--active:hover {\r\n    background-color: #ffe2a8 !important;\r\n    border: 1px solid #ffe2a8 !important;\r\n    border-radius: 0.3rem;\r\n    color: black;\r\n} */\r\n\r\n.react-calendar__tile:enabled:hover {\r\n    background-color: #f3f3f3 !important;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__tile:enabled:hover {\r\n    background-color: #636363 !important;\r\n}\r\n\r\n.react-calendar__tile:enabled:focus,\r\n.react-calendar__tile--active,\r\n.react-calendar__tile--active:hover {\r\n    color: black;\r\n}\r\n\r\n.react-calendar__tile--active abbr {\r\n    background-color: #ffd37e !important;\r\n}\r\n\r\n.react-calendar__month-view__days__day abbr {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.StyledDate {\r\n    border: none;\r\n    box-shadow: none;\r\n    background: #94a3b8;\r\n    font-weight: 500;\r\n    text-shadow: none;\r\n    color: #fff;\r\n    opacity: 1;\r\n    height: 2rem;\r\n    padding: 0 1rem;\r\n    line-height: 2rem;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-left: 20px;\r\n}\r\n\r\n.StyledToday {\r\n    font-size: x-small;\r\n    color: navy;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.StyledDot {\r\n    background-color: navy;\r\n    border-radius: 50%;\r\n    width: 0.3rem;\r\n    height: 0.3rem;\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.StyledEX-hoilday {\r\n    font-size: 11px;\r\n    color: black;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    top: 50px;\r\n    width: 100%;\r\n}\r\n\r\n.StyledEX {\r\n    font-size: 11px;\r\n    color: black;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    top: 80px;\r\n    width: 100%;\r\n}\r\n\r\n.StyledEX-1,\r\n.StyledEX-2,\r\n.StyledEX-3,\r\n.StyledEX-4 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.StyledEX-1 {\r\n    width: 100%;\r\n    /* height: 14px; */\r\n    background-color: #e59e2f !important;\r\n    border-radius: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.StyledEX-2 {\r\n    width: 100%;\r\n    height: 14px;\r\n    background-color: #1c658c !important;\r\n    border-radius: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.StyledEX-3 {\r\n    width: 100%;\r\n    height: 14px;\r\n    background-color: #064e3b !important;\r\n    border-radius: 5px;\r\n}\r\n\r\n.StyledEX-4 {\r\n    width: 100%;\r\n    height: 14px;\r\n    background-color: #6f5689 !important;\r\n    border-radius: 5px;\r\n}\r\n\r\n.StyledEX-holiday {\r\n    width: 100%;\r\n    /* width: calc(100% - 10px); */\r\n    /* height: 14px; */\r\n    background-color: rgb(244, 81, 30);\r\n    text-align: left;\r\n    color: #fff;\r\n    height: 22px;\r\n    line-height: 20px;\r\n    padding: 0 8px;\r\n    margin-bottom: 5px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-radius: 4px;\r\n\r\n    box-sizing: border-box;\r\n    pointer-events: auto;\r\n    overflow: hidden;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    outline: none;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    align-items: center;\r\n}\r\n\r\n/* 전달, 다음 달의 날짜는 회색 */\r\n.react-calendar__month-view__days__day--neighboringMonth {\r\n    background-color: #f9f9f9 !important;\r\n    color: #c5c5c5;\r\n}\r\n\r\n.calendar-right {\r\n    width: 230px;\r\n    border: 2px solid rgb(241, 243, 244);\r\n    margin-top: 85px;\r\n}\r\n\r\n.calendar-right-text {\r\n    padding: 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar-right-holiday {\r\n    height: 45px;\r\n    border-left: 4px solid rgb(244, 81, 30);\r\n    margin: 5px 10px;\r\n    padding: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.calendar-right-day {\r\n    height: 45px;\r\n    border-left: 4px solid #567189;\r\n    margin: 5px 10px;\r\n    padding: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    cursor: pointer;\r\n}\r\n\r\n.calendar-right-day:hover {\r\n    background-color: #f1f1f1;\r\n}\r\n\r\n.calendar-icon {\r\n    padding: 3px 10px;\r\n    border: 1px solid rgba(0, 0, 0, .14);\r\n    border-radius: 5px;\r\n    margin-left: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.calendar-icon:hover {\r\n    background-color: #f1f1f1;\r\n}\r\n\r\n.calendar-icon.active {\r\n    background-color: #e3e3e3;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
